<template>
  <div>
    <!-- Title -->
    <drop-down-menu-item :type="'title'">
      Navigation
    </drop-down-menu-item>

    <drop-down-menu-item
      type="routerLink"
      :link-to="selectOrderLink"
      icon-class="far fa-search"
    >
      Find Order
    </drop-down-menu-item>
    <drop-down-menu-item
      v-if="order.orderState && order.orderState !== 'Closed'"
      type="routerLink"
      :link-to="payOrderLink"
      icon-class="far fa-file-invoice-dollar"
    >
      Pay Order
    </drop-down-menu-item>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';
  import DropDownMenuItem from '../drop-down-menu-item/index.vue';


  export default {
    name: 'PayAtTableNavigation',

    components: {
      DropDownMenuItem
    },

    computed: {
      ...mapGetters('orders', ['order']),
      ...mapGetters('session', ['session']),

      selectOrderLink() {
        return { name: 'payAtTableSelectOrder' };
      },

      payOrderLink() {
        const { orderId } = this.order;

        return {
          name: 'payAtTableCheckout',
          params: {
            merchantId: this.$route.params.merchantId
          },
          query: {
            ml: this.session.route.merchantLocationId,
            oi: orderId,
            tb: this.session.route.tableNumber || this.session.route.ticketNumber,
            ch: this.session.route.channelTypeId,
            ds: this.session.route.disableSplit
          }
        };
      }
    }
  };
</script>
